export class CaseListQueryCase {
  caseTitleText: string;
  caseCategoryText: string;
  caseTrackingId: string;
  caseDocketId: string;
  caseTypeText: string;
  caseCategoryName:string;
}
